import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {hideModal} from '../../../actions/modal.actions';
import { getAccountDetails, getModalData, link, getAdmin, getAuthData } from "../../../selectors";
import Loader from "../../../components/Loader";
import {getPrimaryContacts} from "../../../actions/admin.actions";
import isEmpty from "../../../utils/helpers";
import { toastr } from "react-redux-toastr";

class SendRegistrationLinkModal extends Component {

    state = {
        isSubmitting: false,
        sendResult: false,
        sendMessage: false,
        isLoaded: false,
        contactEmails: [],
        linkedAccounts: [],
        isLoading: true,
        hoverStates: {},
        iconHoverStates: {},
    };

    componentDidMount() {
        this.getCurrentEmail();
        console.log(this.props.userAccount.id)

    }

    componentDidUpdate(prevProps) {
        if (this.props.linkedAccounts !== prevProps.linkedAccounts) {
            this.setState({ linkedAccounts: this.props.linkedAccounts });
            console.log('this is linkedaccounts',this.props.linkedAccounts);
        }
        if (this.props.linkedUsers !== prevProps.linkedUsers) {
            this.setState({ linkedUsers: this.props.linkedUsers });
            console.log('this is linkedUsers', this.props.linkedUsers);
        }
    }

    getCurrentEmail = async () => {
        const {accountId} = this.props;
        if (accountId) {
            await this.props.getPrimaryContacts(accountId).then(r =>{
                this.setState({
                    isLoaded: true,
                    contactEmails: r.data.contacts[0].emails
                })
            });
        }

    }

    handleSendLink = (accountId, destinationEmail) => {

        this.setState({
            isSubmitting: true,
            sendResult: false,
            sendMessage: false
        });

        this.props.sendRegistrationLink({accountId : accountId, email: destinationEmail}).then((response) => {

            if (response.success) {
                this.setState({
                    isSubmitting: false,
                    sendResult: 'success',
                    sendMessage: response.message
                });
            }
            else {
                this.setState({
                    isSubmitting: false,
                    sendResult: 'error',
                    sendMessage: response.error.message
                });
            }
        });
    }

    closeModal = () => {
        this.props.hideModal();
    };

    handleUnLinkConfirmationMessage = (accountObj) => {
        console.log(!accountObj.company === null && !accountObj.company === '')
        if(accountObj && accountObj.company === null || accountObj.company === '' ) {
            return `You are about to unlink ${accountObj.name} account, account # ${accountObj.number}`
        } else  {
            return `You are about to unlink ${accountObj.company} account, account # ${accountObj.number}`
        }
    }

    toggleHover = () => {
        this.setState(prevState => ({ hover: !prevState.hover }));
    }

    handleAction = (type, userId, accountId, accountObj) => {

        if (type === 'unlinkAccount'){

            toastr.confirm(this.handleUnLinkConfirmationMessage(accountObj), {
                cancelText: "Cancel",
                okText: "Confirm",
                onOk: () => {
                    this.handleUnlink(userId, accountId);
                },
                onCancel: () => {
                }
            });

        } else if (type === 'unlinkUser') {
            toastr.confirm(this.handleUnLinkConfirmationMessage(accountObj), {
                cancelText: "Cancel",
                okText: "Confirm",
                onOk: () => {
                    this.handleUnlink(userId, accountId);
                },
                onCancel: () => {
                }
            });
        }

    }

            handleUnlink = (userId, accountId) => {
                const unLinkAccountPayload = {
                    "accountId": accountId,
                    "unregisteredBySystemUserId": this.props.userAccount.id,
                    "userId": userId
                };
                this.props.unLinkAccount(unLinkAccountPayload)
                  .then(() => {
                      this.refreshLinkedAccountsAndUsers();
                  })
                  .catch(error => {
                      console.error('Error unlinking account:', error);
                  });
            }

    render() {

        const {isSubmitting, sendResult, sendMessage, isLoaded, contactEmails} = this.state;

        const {accountId} = this.props;

        let destinationEmail = false;

        if (!isEmpty(contactEmails)) {
            contactEmails.forEach((email) => {
                if (email.type === "BUSINESS" || destinationEmail === false) {
                    destinationEmail = email.email;
                }
            });
        }

        const styles = {
            normal: { color: '#7a8288' },
            hover: { color: '#bf433d',
                cursor: 'pointer'}
        };

        const divStyles =
          {

              borderTop: '1px solid #e5e5e5',
              paddingTop: '10px'
          }

        const topIconStyles = {
            normal: { color: '#7a8288' },
            hover: { color: '#6ab3c2', cursor: 'pointer' }
        };

        return (
            <Fragment>
                <div className="modal" style={{display: 'block'}} tabIndex="-1" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">

                                <h5 className="modal-title">Customer Portal Access</h5>

                                <button onClick={this.closeModal} type="button" className="close">
                                    <span aria-hidden="true">&times;</span>
                                </button>

                            </div>
                            {!isLoaded
                                ?
                                <div className="modal-body">
                                    <Loader/>
                                </div>
                                :
                                <div className="modal-body">

                                    {destinationEmail ? <>
                                        <div className="form-group">
                                            <label>Send registration link to:</label>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">@</span>
                                                </div>
                                                <input type="text" className="form-control" value={destinationEmail} disabled/>
                                            </div>
                                        </div>
                                    </> : <>
                                        No email address found.
                                    </>}

                                    {isSubmitting && <Loader/>}

                                    {sendResult &&
                                    <div className="form-section-customer-payment-management-message">
                                        {sendResult === 'success'
                                            ? <i className="far fa-check-circle text-success"/>
                                            : <i className="far fa-times-circle text-danger"/>
                                        }
                                        <p>{sendMessage}</p>
                                    </div>
                                    }
                                    {this.props.linkedAccounts && this.props.linkedAccounts.linkedAccounts && this.props.linkedAccounts.linkedAccounts.linkedAccountList &&
                                      <>
                                          <div className="text-muted text-sm mt-2" style={divStyles}>
                                              Following users have access to this account. They can view
                                              invoices, pay bills, and signup for AutoPay.
                                          </div>
                                          <div className="cmv-container-table mt-3">
                                              <table className="table cmv-table cmv-table-mobile cmv-table-solid">
                                                  <thead>
                                                  <tr>
                                                      <th>Users</th>
                                                      <th>Account Status</th>
                                                      <th className="text-center">Actions</th>
                                                  </tr>
                                                  </thead>
                                                  <tbody>
                                                  {this.props.linkedAccounts.linkedAccounts.linkedAccountList.map((account, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <div>{account.systemUserContactName}</div>
                                                            {account.systemUserContactEmails[0]
                                                              ? <div className="text-sm text-muted">{account.systemUserContactEmails[0].email}</div>
                                                              : <div className="text-sm text-muted">-</div>
                                                            }
                                                        </td>
                                                        <td>
                                                            <div className={account.accountInfo.accountStatus === "Active" ? "text-success" : account.accountStatus === "Inactive" ? "text-danger" : "text-warning"}>{account.accountInfo.accountStatus}</div>
                                                            <div className={`text-sm text-muted `}>{account.systemUserContactAccountNumbers[0]}</div>
                                                        </td>
                                                        <td className="tr-actions text-center">
                                                            <i onClick={() => this.handleAction("unlinkUser", this.props.primaryContacts.id, account.accountInfo.systemUserId, this.props.userAccount.id)}
                                                               className="fa fa-ban"
                                                               onMouseEnter={() => this.setState(prevState => ({
                                                                   hoverStates: {
                                                                       ...prevState.hoverStates,
                                                                       [index]: true
                                                                   }
                                                               }))}
                                                               onMouseLeave={() => this.setState(prevState => ({
                                                                   hoverStates: {
                                                                       ...prevState.hoverStates,
                                                                       [index]: false
                                                                   }
                                                               }))}
                                                               style={this.state.hoverStates[index] ? styles.hover : styles.normal}
                                                               aria-hidden="true"></i>
                                                        </td>
                                                    </tr>
                                                  ))}
                                                  </tbody>
                                              </table>
                                          </div>
                                      </>
                                    }

                                </div>
                            }


                            <div className="modal-footer">

                                <button onClick={this.closeModal} className="btn" type="button">
                                    Close
                                </button>

                                {isLoaded &&
                                  <button className="btn btn-primary"
                                          disabled={isSubmitting || !destinationEmail || sendResult === "success"}
                                          onClick={() => this.handleSendLink(accountId, destinationEmail)}
                                  >
                                      Send Link
                                  </button>
                                }


                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop show" tabIndex="1"/>
            </Fragment>
        );
    }
}

const mapDispatchToProps = {
    hideModal,
    getPrimaryContacts
};

const mapStateToProps = (state) => {
    const accountId = getAccountDetails(state).accountDetails.accountInfo.id;
    const sendRegistrationLink = getModalData(state).modalProps.sendRegistrationLink;
    const UserId = getModalData(state).modalProps.userId;
    const linkedAccounts = state.linkedAccounts;
    const linkedUsers = state.linkedUsers;
    const primaryContacts = getAdmin(state).primaryContacts;
    const userAccount = getAuthData(state)


    return {
        accountId,
        sendRegistrationLink,
        linkedAccounts,
        linkedUsers,
        UserId,
        primaryContacts,
        userAccount


    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SendRegistrationLinkModal);
